import ValueColor from '@/components/valueColor/ValueColor';
import { numToPctFormat, profitColorSwitch } from '../_utils';

export const ProfitLossView = ({ value, decimal_precision }: { value: number; decimal_precision?: number }) => {
	const valueFormatted = numToPctFormat(value, decimal_precision || 0);
	return (
		<ValueColor variant={profitColorSwitch(value)}>
			{value > 0 && '+'}
			{valueFormatted}
		</ValueColor>
	);
};
